import { Duration } from "luxon";

import { t } from "@lingui/core/macro";

//TODO why is this an enum?
enum IntervalList {
  PT5M = "PT5M",
  PT15M = "PT15M",
  PT20M = "PT20M",
  PT30M = "PT30M",
  PT1H = "PT1H",
  PT3H = "PT3H",
  PT6H = "PT6H",
  PT12H = "PT12H",
  P1D = "P1D",
}

enum ResolutionList {
  PT5M = "PT5M",
  PT10M = "PT10M",
  PT15M = "PT15M",
  PT20M = "PT20M",
  PT30M = "PT30M",
  PT1H = "PT1H",
  PT3H = "PT3H",
  PT6H = "PT6H",
  PT12H = "PT12H",
  P1D = "P1D",
}

const durationDisplayName: Record<string, () => string> = {
  PT5M: () => t`5 m`,
  PT10M: () => t`10 m`,
  PT15M: () => t`15 m`,
  PT20M: () => t`20 m`,
  PT30M: () => t`30 m`,
  PT1H: () => t`1 h`,
  PT3H: () => t`3 h`,
  PT6H: () => t`6 h`,
  PT12H: () => t`12 h`,
  P1D: () => t`1 d`,
  P2D: () => t`2 d`,
  P3D: () => t`3 d`,
  P4D: () => t`4 d`,
  P5D: () => t`5 d`,
};

export interface DurationDesc {
  isoFormatted: string;
  duration: Duration;
  displayName: () => string;
}

export const createDurationOptions = (enumList: Record<string, string>): DurationDesc[] => {
  return Object.entries(enumList).map(([key]) => ({
    isoFormatted: key,
    displayName: durationDisplayName[key],
    duration: Duration.fromISO(key),
  }));
};

export const resolutionOptions: DurationDesc[] = createDurationOptions(ResolutionList);

export const intervalOptions: DurationDesc[] = createDurationOptions(IntervalList);

export const globalRange: { MIN: Date; MAX: Date } = {
  MIN: new Date(1940, 0, 1),
  MAX: new Date(2100, 0, 1),
};
